export function getStorePageHref(page) {
  const configuredTarget =
    typeof page?.link_url === "string" ? page.link_url.trim() : "";
  const isSafeInternalTarget =
    configuredTarget.startsWith("/") && !configuredTarget.startsWith("//");

  // Landing Ads harus selalu membuka renderer /promo/[slug]. Pengecekan
  // prefix juga menjaga kompatibilitas ketika cache/API lama belum mengirim
  // link_type tetapi sudah mengirim link_url yang benar.
  if (
    isSafeInternalTarget &&
    (page?.link_type === "landing_ads" || configuredTarget.startsWith("/promo/"))
  ) {
    return configuredTarget;
  }

  if (page?.link_type === "custom" && isSafeInternalTarget) {
    return configuredTarget;
  }

  // Kompatibilitas shortcut Landing Ads versi awal yang menyimpan slug menu
  // sebagai `promo-{landing-slug}` sebelum link_url ikut terbaca storefront.
  const legacySlug = typeof page?.slug === "string" ? page.slug.trim() : "";
  if (legacySlug.startsWith("promo-") && legacySlug.length > "promo-".length) {
    return `/promo/${encodeURIComponent(legacySlug.slice("promo-".length))}`;
  }

  return `/pages/${encodeURIComponent(legacySlug)}`;
}
